import { PRODUCTS, type ProductId } from '@bb/shared';

/**
 * TanStack Router only accepts `to` values that exist in the generated route
 * tree. Every product has a route file under src/routes/app/<id>/, so the
 * registry's `/app/<id>` paths are always valid; this narrows the shared
 * template-literal type to that union.
 */
export type ProductPath = `/app/${ProductId}`;

export function productPath(id: ProductId): ProductPath {
  return PRODUCTS[id].basePath as ProductPath;
}
